import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TipoService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  // Seccion Tipo Gasto
  getTipoGasto(): Observable<any> {
    return this.http.get(this.baseUrl + 'parTipoGastos', { headers: this.header(this.token) });
  }

  getTipoGastoById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parTipoGasto/' + id, { headers: this.header(this.token) });
  }

  postTipoGasto(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'parTipoGasto', bodyString, { headers: this.header(this.token) });
  }

  putTipoGasto(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'parTipoGasto', bodyString, { headers: this.header(this.token) });
  }

  deleteTipoGasto(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'parTipoGasto/' + id, { headers: this.header(this.token) });
  }

  // Seccion Tipo Intervencion
  getTipoIntervencion(): Observable<any> {
    return this.http.get(this.baseUrl + 'parTipoIntervenciones', { headers: this.header(this.token) });
  }

  getTipoIntervencionById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parTipoIntervencion/' + id, { headers: this.header(this.token) });
  }

  postTipoIntervencion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'parTipoIntervencion', bodyString, { headers: this.header(this.token) });
  }

  putTipoIntervencion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'parTipoIntervencion', bodyString, { headers: this.header(this.token) });
  }

  deleteTipoIntervencion(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'parTipoIntervencion/' + id, { headers: this.header(this.token) });
  }

  getTipoIntervencionByTG(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parTiposIntervencionGasto/' + id, { headers: this.header(this.token) });
  }
}
